import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/form.css';
import './styles/button.css';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(() => console.log('Service Worker registered'))
    .catch(err => console.error('SW registration failed', err));
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);